import React from 'react';
import Tippy from '@tippyjs/react';
import { getUserUrl } from '../../utilities/urlHelper';
import useUser from '../../hooks/useUser';

const NO_AVATAR = '/img/avatars/crab.png';

const AuthorAvatar = (props) => {
    const { userId, user: propUser } = props;
    const loadedUser = useUser(parseInt(userId, 10));

    const user = propUser || loadedUser;
    if (!user) return null;

    const {
        image_192 = NO_AVATAR,
        display_name = '',
        image,
        name,
        url: userUrl,
        id,
    } = user;

    let {
        tooltip = 'Owned by',
        customClass = 'avatar block mx-auto',
        customLinkClass = 'owner__avatar',
        noLink = false,
        imgHeight = 28,
        imgWidth = 28,
    } = props;

    tooltip = tooltip.includes('you') ? tooltip : `${tooltip} ${display_name || name}`;
    const url = userUrl || getUserUrl(id);
    customClass += user.deactivated_at ? ' grayscale-img' : '';

    if (noLink) {
        return (
            <Tippy content={tooltip} placement="bottom">
                <img
                    className={customClass}
                    src={image_192}
                    width={imgWidth}
                    height={imgHeight}
                    alt="avatar"
                />
            </Tippy>
        );
    }

    return (
        <a className={customLinkClass} href={url} style={{ width: imgWidth }}>
            <Tippy content={tooltip} placement="bottom">
                <img
                    className={customClass}
                    src={image_192}
                    width={imgWidth}
                    height={imgWidth}
                    alt="avatar"
                />
            </Tippy>
        </a>
    );
};

export default AuthorAvatar;
